import { Theme } from '@emotion/react';
import { createTheme } from '@mui/material';

export const appTheme: Theme = createTheme({
  palette: {
    action: {
      hoverOpacity: 0.1
    }
  },
  typography: {
    fontFamily: 'inherit'
  }
});
